/**
 * 防抖 Hook
 * 用于延迟更新值，避免频繁触发操作（如 API 调用）
 */

import { useState, useEffect } from 'react'

/**
 * 防抖 Hook
 * @param value - 需要防抖的值
 * @param delay - 防抖延迟时间（毫秒），默认 300ms
 * @returns 防抖后的值
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value)
    }, delay)

    return (): void => {
      clearTimeout(timer)
    }
  }, [value, delay])

  return debouncedValue
}
